














































import Vue from 'vue';

type SizePriceItem = {
  sizeOptionSn?: string;
  sizeName?: string;
  unitPrice?: number | string;
  sequence?: number;
};

type MicroSprayProductCardItem = {
  targetSn?: string;
  productSn?: string;
  id?: string | number;
  name?: string;
  description?: string;
  imageUrl?: string;
  supplierName?: string;
  studioName?: string;
  priceText?: string;
  sizePriceList?: SizePriceItem[];
  favorited?: boolean;
  saleStatusName?: string;
  canPurchase?: boolean;
};

export default Vue.extend({
  name: 'MicroSprayProductCard',
  props: {
    item: {
      type: Object as () => MicroSprayProductCardItem,
      required: true,
    },
    showFavorite: {
      type: Boolean,
      default: false,
    },
    favoriteLoading: {
      type: Boolean,
      default: false,
    },
    selectLabel: {
      type: String,
      default: '选购商品',
    },
    favoriteAt: {
      type: String,
      default: '',
    },
    selectOnCardClick: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayName(): string {
      return this.item.name || this.item.description || '未填写商品名称';
    },
    priceText(): string {
      if (this.item.priceText) {
        return this.item.priceText;
      }
      const priceList = Array.isArray(this.item.sizePriceList) ? [...this.item.sizePriceList] : [];
      const text = priceList
        .sort((left, right) => Number(left.sequence || 0) - Number(right.sequence || 0))
        .map(price => {
          const sizeName = price.sizeName || price.sizeOptionSn || '--';
          const amount = Number(price.unitPrice || 0);
          return `${sizeName}: ¥${amount.toFixed(2)}`;
        })
        .join(' / ');
      return text || '未配置尺寸价格';
    },
  },
  methods: {
    handleSelect() {
      if (this.item.canPurchase === false) {
        return;
      }
      this.$emit('select', this.item);
    },
    handleCardSelect() {
      if (this.selectOnCardClick) {
        this.handleSelect();
      }
    },
  },
});
